var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFooter)?_c('div',{attrs:{"id":"homeAppFooter"},domProps:{"innerHTML":_vm._s(_vm.footerContents)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }